module.exports = __webpack_public_path__ + "19d6117827e58030ac9f2550e8b451eb.pdf";